import React, { FC, useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import { fetchData, getEncryptedRoute, toasterrormsg, toastsuccessmsg, useMenuIdPermissions } from '../../../reusable';
import { ToastContainer } from 'react-toastify';
import { AddHotelHeader } from './AddHotelHeader';
import { config } from '../../../reusable'
import JoditEditor from 'jodit-react';
import { Tr } from '../../../_metronic/i18n/Tr';

const AddHotelDetails: FC = () => {
    let t = Tr()

    const location = useLocation();
    const editHotelId = (location.state as any)?.hotelId || '';
    const [hotelDetails, setHotelDetails] = useState([]);
    const primaryLanguage = sessionStorage.getItem("primaryLanguage");
      const {menuId} = useMenuIdPermissions()


    var vendorId = "";
    const vendorData = sessionStorage.getItem("vendor");
    if (vendorData) {
        var vendor = JSON.parse(vendorData);
        vendorId = vendor.vendorId;

    } else {
    }
    const editorRef = useRef(null) as any
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)
    const [disable, setDisable] = useState(false);
    const [generalInformationEN, setGeneralInformationEN] = useState("");
    const [generalInformationRU, setGeneralInformationRU] = useState("");
    const [generalInformationUZ, setGeneralInformationUZ] = useState("");

    // set error state
    const [error, setError] = useState([{

        generalInformationEN: '',
        generalInformationRU: '',
        generalInformationUZ: '',
    }])

    // remove validation function
    const removeError = (err: any) => {
        var tmp = [...error] as any;
        tmp[0][err] = "";
        setError(tmp);
    }

    
    const validate = () => {

        var isValid = true;
        var errorTmp = [...error];

        if (primaryLanguage == "English") {

            if (generalInformationEN.trim() == "" || generalInformationEN.trim() == null || generalInformationEN.trim() == undefined) {
                errorTmp[0].generalInformationEN = t('Property Description Is Required');
                isValid = false;
            }
        } else if (primaryLanguage == "Russian") {
            if (generalInformationRU.trim() == "" || generalInformationRU.trim() == null || generalInformationRU.trim() == undefined) {
                errorTmp[0].generalInformationRU = t('Property Description Is Required');
                isValid = false;
            }
        } else if (primaryLanguage == "Uzbek") {
            if (generalInformationUZ.trim() == "" || generalInformationUZ.trim() == null || generalInformationUZ.trim() == undefined) {
                errorTmp[0].generalInformationUZ = t('Property Description Is Required');
                isValid = false;
            }
        }

        setError(errorTmp);
        return isValid;
    }
    // add hotel details call
    const addHotelsDetailApi = async () => {

        if (validate()) {

            setDisable(true)
            setLoading(true);
            let param = {
                hotelId: editHotelId,
                en_generalInformation: generalInformationEN,
                ru_generalInformation: generalInformationRU,
                uz_generalInformation: generalInformationUZ,
            }
            var res = await fetchData("vendor/public/addPropertyDetails", param)
            if (res.status == "200") {
                toastsuccessmsg("Details Added Successfully!")
                const state = {
                    hotelId: editHotelId
                }
                setTimeout(() => {
                              navigate(getEncryptedRoute('../addhotelpolicies/', {menuId:menuId}), {state})
                    
                    setDisable(false)
                }, 1500);
            }
            else {
                toasterrormsg(res.message)
                setDisable(false)

            }
        }
    }
    // hotel Details api call
    const hotelDetailsApiCall = async () => {
        var param: any = {
            hotelId: editHotelId,
        }
        var response: any = await fetchData("vendor/public/hotelDetailsV2", param)
        if (response.status == "200") {
            setHotelDetails(response.data)
            var data = response.data[0]
            setGeneralInformationEN(data.en_generalInformation)
            setGeneralInformationRU(data.ru_generalInformation)
            setGeneralInformationUZ(data.uz_generalInformation)
        }
        else {
            toasterrormsg(response.message)
        }
    }



    useEffect(() => {

        if (editHotelId != "") {

            hotelDetailsApiCall();
        }
    }, [])

    return (
        <>
            <ToastContainer />
            <PageTitle breadcrumbs={[]}>{editHotelId != "" ? t('Edit Property Details') : t('Add Property Details')}</PageTitle>
            <AddHotelHeader hotelId={editHotelId} />
            <div className="d-flex flex-column flex-column-fluid">
                {/* <!--begin::Content--> */}
                <div id="kt_app_content" className="app-content flex-column-fluid">
                    {/* <!--begin::Form--> */}
                    <div className="form d-flex flex-column flex-lg-row">
                        {/* <!--begin::Main column--> */}
                        <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                            {/* <!--begin::Tab content--> */}
                            <div className="tab-content">
                                {/* <!--begin::Tab pane--> */}
                                <div className="tab-pane fade show active" id="kt_ecommerce_add_product_general" role="tab-panel">
                                    <div className="d-flex flex-column">
                                        {/* <!--begin::General options--> */}
                                        <div className="card card-flush py-4">
                                            {/* <!--begin::Card header--> */}
                                            <div className="card-header d-flex">
                                                {/* <!--begin::Card title--> */}
                                                <div className="card-title">
                                                    <h2>{t("Property Details")}</h2>
                                                </div>
                                                {/* <!--end::Card title--> */}
                                                <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                                                    {
                                                        hotelDetails.length != 0 ? (
                                                            <>
                                                                {
                                                                    hotelDetails.map((completedSteps: any, index: any) => {
                                                                        var percentage = 0;
                                                                        if (completedSteps['completedSteps']['basicInfo']) {
                                                                            percentage = 10;
                                                                        }
                                                                        if (completedSteps['completedSteps']['location']) {
                                                                            percentage = 20;
                                                                        }
                                                                        if (completedSteps['completedSteps']['propertyDetail']) {
                                                                            percentage = 40;
                                                                        }
                                                                        if (completedSteps['completedSteps']['roomAndSpace']) {
                                                                            percentage = 50;
                                                                        }
                                                                        if (completedSteps['completedSteps']['photos']) {
                                                                            percentage = 60;
                                                                        }
                                                                        if (completedSteps['completedSteps']['facilitiesAndServices']) {
                                                                            percentage = 70;
                                                                        }
                                                                        if (completedSteps['completedSteps']['policies']) {
                                                                            percentage = 90;
                                                                        }
                                                                        if (completedSteps['completedSteps']['financeAndLegal']) {
                                                                            percentage = 100;
                                                                        }
                                                                        return (
                                                                            <>
                                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                                    <span className='fw-bold fs-6'>{t("Completion")}</span>
                                                                                    <span className='fw-bolder fs-6'>{percentage}%</span>
                                                                                </div>
                                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                                    <div
                                                                                        className='bg-success rounded h-5px'
                                                                                        role='progressbar'
                                                                                        style={{ width: `${percentage}%` }}
                                                                                    ></div>
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                    <span className='fw-bold fs-6'>{t("Completion")}</span>
                                                                    <span className='fw-bolder fs-6'>0%</span>
                                                                </div>
                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                    <div
                                                                        className='bg-success rounded h-5px'
                                                                        role='progressbar'
                                                                        style={{ width: '0%' }}
                                                                    ></div>
                                                                </div>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            {/* <!--end::Card header--> */}
                                            {/* <!--begin::Card body--> */}
                                            <div className="card-body pt-10">
                                                {/* <!--begin::Input group--> */}
                                                {
                                                    primaryLanguage == "English" && (
                                                        <>
                                                            <div className="row">
                                                                <div className="col-lg-12 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="required fs-5 form-label">{t("General Information (English)")}</label>
                                                                  
                                                                    <JoditEditor
                                                                        ref={editorRef}
                                                                       config={config()} 
                                                                        value={generalInformationEN}
                                                                        onBlur={newContent => { setGeneralInformationEN(newContent); removeError("generalInformationEN"); }} />
                                                                    <div className='text-danger fw-bold'>{error[0].generalInformationEN}</div>
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-12 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-5 form-label">{t("General Information (Russian)")}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <JoditEditor
                                                                        ref={editorRef}
                                                                        config={config()} 
                                                                        value={generalInformationRU}
                                                                        onBlur={newContent => { setGeneralInformationRU(newContent); }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-12 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-5 form-label">{t("General Information (Uzbek)")}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <JoditEditor
                                                                        ref={editorRef}
                                                                        config={config()}
                                                                        value={generalInformationUZ}
                                                                        onBlur={newContent => { setGeneralInformationUZ(newContent); }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                                {
                                                    primaryLanguage == "Russian" && (
                                                        <>
                                                            <div className="row">
                                                                <div className="col-lg-12 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="required fs-5 form-label">{t("General Information (Russian)")}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <JoditEditor
                                                                        ref={editorRef}
                                                                        config={config()}
                                                                        value={generalInformationRU}
                                                                        onBlur={newContent => { setGeneralInformationRU(newContent); removeError("generalInformationRU"); }} />
                                                                    <div className='text-danger fw-bold'>{error[0].generalInformationRU}</div>
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-12 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className=" fs-5 form-label">{t("General Information (English)")}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <JoditEditor
                                                                        ref={editorRef}
                                                                        config={config()}
                                                                        value={generalInformationEN}
                                                                        onBlur={newContent => { setGeneralInformationEN(newContent);}} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-12 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-5 form-label">{t("General Information (Uzbek)")}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <JoditEditor
                                                                        ref={editorRef}
                                                                        config={config()}
                                                                        value={generalInformationUZ}
                                                                        onBlur={newContent => { setGeneralInformationUZ(newContent);}} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                                {
                                                    primaryLanguage == "Uzbek" && (
                                                        <>
                                                            <div className="row">
                                                                <div className="col-lg-12 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="required fs-5 form-label">{t("General Information (Uzbek)")}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <JoditEditor
                                                                        ref={editorRef}
                                                                        config={config()}
                                                                        value={generalInformationUZ}
                                                                        onBlur={newContent => {setGeneralInformationUZ(newContent); removeError("generalInformationUZ"); }} />
                                                                    <div className='text-danger fw-bold'>{error[0].generalInformationUZ}</div>
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-12 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-5 form-label">{t("General Information (Russian)")}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <JoditEditor
                                                                        ref={editorRef}
                                                                        config={config()}
                                                                        value={generalInformationRU}
                                                                        onBlur={newContent => {setGeneralInformationRU(newContent);}} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-12 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className=" fs-5 form-label">{t("General Information (English)")}</label>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <JoditEditor
                                                                        ref={editorRef}
                                                                        config={config()}
                                                                        value={generalInformationEN}
                                                                        onBlur={newContent => {setGeneralInformationEN(newContent);}} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                                {/* <!--end::Input group--> */}
                                            </div>
                                            {/* <!--end::Card body--> */}
                                        </div>
                                        {/* <!--end::Pricing--> */}
                                    </div>
                                </div>
                                {/* <!--end::Tab pane--> */}
                            </div>
                            {/* <!--end::Tab content--> */}
                            <div className="d-flex justify-content-end">
                               
                                <button type="button" disabled={disable} className="btn btn-primary" onClick={addHotelsDetailApi}>
                                    <span className="indicator-label">{t("Next")}</span>
                                    {loading && (
                                        <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                    )}
                                </button>
                                {/* <!--end::Button--> */}
                            </div>
                        </div>
                        {/* <!--end::Main column--> */}
                    </div>
                    {/* <!--end::Form--> */}
                </div>
                {/* <!--end::Content--> */}
            </div>
        </>
    )
}

export { AddHotelDetails }
